import { getCookie } from './cookieService';

/**
 *
 * @param cname
 * @param cvalue
 * @param exdays
 */
export function lSsetCookie( cname, cvalue ) {
    localStorage.setItem( cname, cvalue );
}

/**
 *
 * @param cname
 * @returns {string}
 */
export function lSgetCookie( cname ) {
    return localStorage.getItem( cname );
}

/**
 *
 * @param cname
 * @returns {boolean}
 */
export function lScheckCookie( cname ) {
    if ( typeof window !== 'undefined' ) {
        const user = getCookie( cname );
        return user !== '' && user !== null;
    } else {
        return false;
    }

}

export function lSdeleteCookie( name ) {
    lSsetCookie( name, null );
}


